import React from 'react';
import { NotFound } from './NotFound';
import { FormIntro } from '../components/form/FormIntro';
import { FormCard } from '../components/form/FormCard';
import { SupportPanel } from '../components/form/SupportPanel';
import { formVariants } from '../data/forms';
import type { FormPreviewState } from '../types/form';
type FormPageProps = {
  variantId: string;
  preview?: FormPreviewState;
};
export function FormPage({
  variantId,
  preview = 'live'
}: FormPageProps) {
  const variant = formVariants[variantId];
  if (!variant) return <NotFound data-id="element-2042" data-mp="2b1y6rnuq63cs" />;
  return <main className="hero-surface w-full" data-id="element-2043" data-mp="2b5c7krnqq4i4">
      <div className="mx-auto grid max-w-shell grid-cols-1 gap-8 px-6 py-10 sm:py-14 lg:grid-cols-[minmax(0,1fr)_minmax(0,560px)] lg:gap-x-16 lg:gap-y-10 lg:py-20" data-id="element-2044" data-mp="1wewj94012gfq">
        <div className="lg:col-start-1 lg:row-start-1" data-id="element-2045" data-mp="21b3k4idkh1qt">
          <FormIntro variant={variant} data-id="element-2046" data-mp="2p28xmqw1bhxy" />
        </div>
        <div className="lg:col-start-2 lg:row-span-2 lg:row-start-1" data-id="element-2047" data-mp="2ttr1pntctyn5">
          <FormCard variant={variant} preview={preview} data-id="element-2048" data-mp="2tvtyqrsxcs1d" />
        </div>
        <div className="pt-4 lg:col-start-1 lg:row-start-2 lg:pt-0" data-id="element-2049" data-mp="mxf7asbaphk">
          <SupportPanel variant={variant} data-id="element-2050" data-mp="3rsyuxwn8279j" />
        </div>
      </div>
    </main>;
}